import React from "react";
import {
  DesktopTableContainer,
  ActivitiesCardWrapper,
  TableScrollWrapper,
  ActivitiesTable,
} from "../PatientPortal.styles";
import { convertirDecimalAnios } from "../../../utils/dateUtils";

export default function PatientPortalResultTable({ data }) {
  const isVigente = (item) => {
    return item?.Vigencia === "Vigente" || item?.vigencia === "Vigente";
  };

  const getUltimaActividad = (item) => {
    const fecha = item?.MaxDeFecha_APIM || item?.ultimaActividad;
    if (!fecha || String(fecha).trim() === "") return "--";
    return fecha;
  };

  const getResultado = (item) => {
    const res = item?.Cod_Diagnostico || item?.resultado;
    if (!res || String(res).trim() === "" || !item?.MaxDeFecha_APIM) return "--";
    return res;
  };

  const getFrecuencia = (item) => {
    const vig = item?.MinDeVigencia ?? item?.minDeVigencia;
    if (vig === undefined || vig === null || String(vig).trim() === "") return "--";
    return convertirDecimalAnios(vig);
  };

  const getEstado = (item) => {
    return isVigente(item) ? "Vigente" : "Pendiente";
  };

  const renderAlertIcon = (item) => {
    if (isVigente(item)) {
      // Círculo Verde con Checkmark Blanco
      return (
        <svg
          width="18"
          height="18"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          title="Actividad Vigente"
        >
          <circle cx="10" cy="10" r="10" fill="#10B981" />
          <path
            d="M6 10.2L8.8 13L14.2 7.2"
            stroke="#FFFFFF"
            strokeWidth="2.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    } else {
      // Triángulo Naranja con Signo de Exclamación Blanco
      return (
        <svg
          width="18"
          height="16"
          viewBox="0 0 20 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          title="Actividad Pendiente"
        >
          <path
            d="M8.27 1.87C9.04 0.54 10.96 0.54 11.73 1.87L18.73 13.97C19.5 15.3 18.54 17 17.0 17H3.0C1.46 17 0.5 15.3 1.27 13.97L8.27 1.87Z"
            fill="#E67E22"
          />
          <path
            d="M10 6.5V10.5"
            stroke="#FFFFFF"
            strokeWidth="2"
            strokeLinecap="round"
          />
          <circle cx="10" cy="13.5" r="1.1" fill="#FFFFFF" />
        </svg>
      );
    }
  };

  return (
    <DesktopTableContainer>
      <ActivitiesCardWrapper>
        {/* Título de la tarjeta */}
        <div className="card-header-bar">
          <h3 className="card-title">
            Actividades de Promoción y Mantenimiento de la Salud
          </h3>
        </div>

        {/* Tabla de Actividades y Resultados */}
        <TableScrollWrapper>
          <ActivitiesTable>
            <thead>
              <tr>
                <th>ACTIVIDAD</th>
                <th>FRECUENCIA</th>
                <th>ÚLTIMA ACT.</th>
                <th>RESULTADO</th>
                <th>ESTADO</th>
                <th className="col-alert">ALERTA</th>
              </tr>
            </thead>
            <tbody>
              {data && data.length > 0 ? (
                data.map((item, index) => (
                  <tr key={item.cons || item.consecutivo || `act-row-${index}`}>
                    {/* Actividad */}
                    <td className="activity-name">
                      {item.APIM || item.actividad || "N/A"}
                    </td>

                    {/* Frecuencia */}
                    <td className="col-freq">{getFrecuencia(item)}</td>

                    {/* Última Actividad */}
                    <td className="col-date">{getUltimaActividad(item)}</td>

                    {/* Resultado */}
                    <td className="col-result">{getResultado(item)}</td>

                    {/* Estado */}
                    <td className="col-status">{getEstado(item)}</td>

                    {/* Alerta */}
                    <td className="col-alert">{renderAlertIcon(item)}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td
                    colSpan={6}
                    style={{
                      textAlign: "center",
                      padding: "20px",
                      color: "#64748b",
                    }}
                  >
                    Sin actividades de salud registradas
                  </td>
                </tr>
              )}
            </tbody>
          </ActivitiesTable>
        </TableScrollWrapper>
      </ActivitiesCardWrapper>
    </DesktopTableContainer>
  );
}
